
import { createReducer, on } from '@ngrx/store';
import { loadForm, saveForm, updateForm } from './formFormateur.actions';

export interface FormState {
    formFormateur:{
        data:{}
    }
}

export const initialFormState: FormState = {
    formFormateur:{
        data:{}
    }
};

export const formFormateurReducer = createReducer(
    initialFormState,

    on(loadForm, (state) => ({ ...state, loading: true })),

    on(saveForm, (state) => ({ ...state, loading: true })),

    on(updateForm, (state, data) => ({
        ...state,
        data
    }))
);